import {Component, Input, OnInit} from '@angular/core';
import {AbstractFields} from '../_abstract';
import {FormArray, FormGroup} from '@angular/forms';
import {AttestationService} from '../../services/wizard-form-groups-services/nested-forms/attestation.service';

@Component({
    selector: 'app-attestation-fields',
    template: `
        <div class="wizard-content">
            <div class="wizard-content__aside">
                <div class="wizard-content__sticky">
                </div>
            </div>
            <div class="wizard-content__main">
                <p>
                    <small>
                        Внимание! Укажите объекты контроля для каждого метода отдельно,
                        для вашего удобства по умолчанию начиная со второго метода выбранные объекты дублируются с первого метода.
                    </small>
                </p>
                <hr class="form-page-view__divider">
                <ng-container *ngFor="let group of nestedForms">
                    <app-attestation-method [form]="group"></app-attestation-method>
                    <hr class="form-page-view__divider">
                </ng-container>
                <app-form-group [fbControl]="form.get('list')">
                    <button type="button" class="button-dashed" (click)="onAddClick()" style="width: 350px">
                        + Добавить метод контроля
                    </button>
                </app-form-group>
            </div>
        </div>
    `
})

export class AttestationComponent extends AbstractFields implements OnInit {

    public nestedForms: FormGroup[] = [];

    constructor(
        private attestationService: AttestationService,
    ) {
        super();
    }

    ngOnInit() {
        this.nestedForms = (this.form.get('list') as FormArray).controls as FormGroup[];
    }

    onAddClick() {
        this.attestationService.add();
    }
}
